import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SkipSelf,
  TemplateRef,
} from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  FormArray,
  ControlContainer,
} from '@angular/forms';

@Component({
    selector: 'owners-form',
    templateUrl: './owners-form.component.html',
    styleUrls: ['./owners-form.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class OwnersFormComponent implements OnInit {
  @Input() withOwnerArray: boolean;

  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @ContentChild('ownerTemplate', { static: true })
  ownerTemplate: TemplateRef<any>;

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit() {}

  get form() {
    return this.formGroupDirective.form;
  }
  submit() {
    this.onSubmit.emit();
  }
}
